export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const UPDATE_SELECTED_LANGUAGE = "UPDATE_SELECTED_LANGUAGE";
